export default __webpack_public_path__ + "static/media/sorry-we're-closed.adb63075.png";